import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import ShowMoreComponent from '@Components/Results/utils/show-more.component';
import StickyTableHeaderComponent from '@Components/Results/sticky-table-header.component';

export default class ReactionProtectingGroups extends React.Component {
  constructor(props) {
    super(props);

    this.defaultLimit = 7;

    this.state = {
      currentLength: this.defaultLimit,
    };

    this.showAll = this.showAll.bind(this);
    this.showLess = this.showLess.bind(this);
  }

  showAll() {
    const { detail } = this.props;
    this.setState({ currentLength: detail.protectingGroups.length });
    return Promise.resolve();
  }

  showLess() {
    this.setState({ currentLength: this.defaultLimit });
  }

  render() {
    const { detail } = this.props;
    const { currentLength } = this.state;
    const headers = [
      { id: 'results', order: 1, hasContent: true, title: 'Results' },
      {
        id: 'functional',
        order: 2,
        hasContent: true,
        title: `Functional ${detail.functionalGroup ? detail.functionalGroup : ''}`,
        colspan: 2,
      },
    ];

    return (
      <div className="additional-data-tables">
        <div className="clearfix protecting-groups-container p-left10">
          <table className="rx-table sticky-table-header rx-table--protecting-groups">
            <StickyTableHeaderComponent headers={headers} staticColumns showAllNonEmptyCols={false} />
            <tbody>
              {detail.protectingGroups.slice(0, currentLength).map((group, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={index}>
                  <td>
                    {index + 1} of {detail.protectingGroups.length}
                  </td>
                  <td>Example</td>
                  <td>
                    <div className="protecting-groups-cell">
                      {group.type && (
                        <div className="protecting-groups-cell--row">
                          <span className="property-title">Type</span>
                          <InnerHTML tag="span" html={group.type} mode="escape" />
                        </div>
                      )}

                      {group.conditions && (
                        <div className="protecting-groups-cell--row">
                          <span className="property-title">Condition</span>
                          <InnerHTML tag="span" html={group.conditions} mode="escape" />
                        </div>
                      )}

                      {group.comment && (
                        <div className="protecting-groups-cell--row">
                          <span className="property-title">Comment</span>
                          <InnerHTML tag="span" html={group.comment} mode="escape" />
                        </div>
                      )}

                      {group.citation && (
                        <div className="protecting-groups-cell--row">
                          <span className="property-title">Citation</span>
                          <InnerHTML tag="span" html={group.citation} mode="escape" />
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="rx-btn-group--center">
            <ShowMoreComponent
              initial={this.defaulLimit}
              current={currentLength}
              total={detail.protectingGroups.length}
              container=".protecting-groups-container"
              moreHandler={this.showAll}
              lessHandler={this.showLess}
              threshold={detail.protectingGroups.length}
            />
          </div>
        </div>
      </div>
    );
  }
}

ReactionProtectingGroups.propTypes = {
  detail: PropTypes.object.isRequired,
};
